import { ChevronLeft, Search } from '@watersport/ui-react-icons'
import { Button, Input } from '@watersport/ui-react-next'
import React from 'react'

interface LocationModalHeaderProps {
  value: string
  onChange: (v: string) => void
  onClear: () => void
  onClose: () => void
}

const LocationModalHeader: React.FC<LocationModalHeaderProps> = ({
  value,
  onChange,
  onClear,
  onClose,
}) => (
  <div className="flex w-full space-x-3">
    <Button
      className="py-6 bg-blue-600"
      variant={'default'}
      leftIcon={<ChevronLeft width={28} height={28} />}
      onClick={onClose}
      containerClassName="w-13 flex flex-1"
    />
    <Input
      className="flex flex-1 rounded-xl"
      value={value}
      onChange={onChange}
      placeholder={'Where?'}
      icon={<Search width={24} height={24} className="text-blue-700" />}
      inputClassName="h-[26px]"
      onClear={onClear}
    />
  </div>
)

export default LocationModalHeader
